import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import Editor from "@monaco-editor/react";
import { CircularProgress } from "@mui/material";
import { useSnackbar } from "notistack";
import axios from "../../../utils/axiosInstance";

const ViewVersion = () => {
    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const [jsonConfig, setJsonConfig] = useState("");
    const [loader, setLoader] = useState(false);
    const editorRef = useRef<any>(null);
    const queryParams = new URLSearchParams(location.search);
    const getConfigId = () => queryParams.get("configId");
    const moduleType = () => queryParams.get("module"); // config / locale
    const [configDetails, setConfigDetails] = useState<any>(null);

    const bindJsonInEditor = (value: any) => {
        if (value) {
            editorRef.current.setValue(JSON.stringify(value, null, 2));
            editorRef.current.getAction("editor.action.formatDocument").run();
        } else {
            enqueueSnackbar("No configuration found", { variant: "warning" });
        }
    };

    function handleEditorDidMount(editor: any, monaco: any) {
        editorRef.current = editor;
        // check if the operation is for save or edit
        getJSONInfoById();
    }

    const getJSONInfoById = () => {
        const configId: any = getConfigId();
        if (moduleType() === "locale") {
            getLocaleConfigById(configId);
        } else {
            getConfigurationById(configId);
        }
    };

    // make API call for getting the config details
    const getConfigurationById = async (id: string) => {
        try {
            setLoader(true);
            const config = await axios.get(
                process.env.BASE_URL + "api/v1/cms/config/" + id
            );
            if (config.data) {
                setConfigDetails(config.data?.data);
                jsonEditorBind(config.data?.data?.configJson);
            } else {
                enqueueSnackbar(config.data.message, { variant: "error" });
            }
        } catch (error) {
            console.log("Error fetchng the configuration", error);
            return null;
        } finally {
            setLoader(false);
        }
    };

    const getLocaleConfigById = async (id: string) => {
        try {
            setLoader(true);
            const config = await axios.get(
                process.env.BASE_URL + "api/v1/cms/locale/" + id
            );
            console.log(config.data);
            if (config.data) {
                setConfigDetails(config.data);
                jsonEditorBind(config.data?.configJson);
            } else {
                enqueueSnackbar(config.data.message, { variant: "error" });
            }
        } catch (error) {
            console.log("Error fetchng the configuration", error);
            return null;
        } finally {
            setLoader(false);
        }
    };

    // check if json is valid & bind it in json editor
    const jsonEditorBind = (value: any) => {
        if (value) {
            editorRef.current.setValue(JSON.stringify(value));
            editorRef.current.getAction("editor.action.formatDocument").run();
        } else {
            enqueueSnackbar("No configuration found", { variant: "warning" });
        }
    };

    return (
        <div className="max-width">
            <h4>
                View Configuration Version{" "}
                {loader && <CircularProgress size={30} />}
            </h4>
            <Editor
                theme="vs-dark"
                height="80vh"
                options={{
                    autoIndent: "brackets",
                    wrappingIndent: "indent",
                    wordWrap: "on",
                }}
                defaultLanguage="json"
                // onChange={validateJson}
                onMount={handleEditorDidMount}
            />
        </div>
    );
};

export default ViewVersion;
